import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { MDash } from 'ui-components/components/mdash';

import { emptyObject } from 'ui-components/default-props/empty';

import { messages } from '../../messages';
import FormattedCurrency from '../../../../../../components/formatted-currency';

const InsuranceCell = ({ value }) => {
  const { code, value: insuredValue } = value || emptyObject;

  return !insuredValue ? <MDash /> : <FormattedCurrency currencyCode={code} value={insuredValue} />;
};

export const createInsuranceColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'insuredValue',
  Header: <FormattedMessage {...messages.insuranceColumnHeader} />,
  Cell: InsuranceCell,
  width: 1,
  minWidth: 100,
});
